/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit CheckOut/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import CheckOutAction from 'DesignSystem/CheckOutAction/index'
import React from 'react'
import TysiaButtonWithText from 'DesignSystem/TysiaButtonWithText/index'



/** @type {import('Simple/types.js').View} */
export default function CheckOut({
  children,
  viewPath = "/DesignSystem/TimelineEvent/Appointment/Actions/Scheduled/Primary/Content/CheckOut"
  
}) {
let eventAppointmentBookingIdValueData = fromData.useDataValue({ viewPath,
context: 'event',
path: 'appointment.booking._id',
})
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
  return (<React.Fragment
>
<CheckOutAction
  viewPath={`${viewPath}/CheckOutAction`}
 data="event.appointment.booking._id"
 appointmentBookingId={eventAppointmentBookingIdValueData}
>
{childProps => (
<TysiaButtonWithText
{...childProps}
  viewPath={`${viewPath}/TysiaButtonWithText`}
 type="secondary"
 size="small"
 marginLeft={dtSpaceXxs}
 text="Checkout"
/>
)}
</CheckOutAction>
{children}
</React.Fragment>)
}